// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"d95b557d","618":"70cb3e17"}[chunkId] + ".chunk.css";
};